import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { v4 as uuidv4 } from "uuid";

const useStyles = makeStyles({
  root: { marginBottom: 20 },
  media: {
    height: 300,
    width: 100,
  },
});

let productList = [
  {
    type: "mist",
    name: "Bronza, Hydrating Bronzing Mist 100 ml",
    imageUrl:
      "https://lykostatic.com/globalassets/product-images/bronza-hydrating-bronzing-mist-100ml-2934-100-0100_1.jpg?ref=825592&w=960&h=960&mode=max&quality=75&format=webp",
    targetUrl:
      "https://ion.lyko.com/t/t?a=1117786221&as=1495527331&t=2&tk=1&epi=quiz&url=https://lyko.com/sv/bronza/bronza-hydrating-bronzing-mist-100ml",
  },
  {
    type: "medium",
    name: "Ida Warg, Instant Self-Tanning Mousse Medium Dark 150 ml",
    imageUrl:
      "https://lykostatic.com/globalassets/product-images/ida-warg-instant-self-tanning-mousse-medium-dark-150ml-2300-104-0150_1.jpg?ref=834407&w=1280&h=1280&mode=max&quality=75&format=webp",
    targetUrl:
      "https://ion.lyko.com/t/t?a=1117786221&as=1495527331&t=2&tk=1&epi=quiz&url=https://lyko.com/sv/ida-warg/ida-warg-instant-self-tanning-mousse-med",
  },
  {
    type: "dark",
    name: "Bronza, Bronzing Mousse Natural Bronze",
    imageUrl:
      "https://lykostatic.com/globalassets/product-images/bronza-bronzing-mousse-natural-bronze-200-ml-2934-102-0200_1.jpg?ref=832926&w=960&h=960&mode=max&quality=75&format=webp",
    targetUrl:
      "https://ion.lyko.com/t/t?a=1117786221&as=1495527331&t=2&tk=1&epi=quiz&url=https://lyko.com/sv/bronza/bronza-bronzing-mousse-natural-bronze-200-ml",
  },
  {
    type: "mousse",
    name: "Ida Warg, Self-Tanning Mousse 150 ml",
    imageUrl:
      "https://lykostatic.com/globalassets/product-images/ida-warg-self-tanning-mousse-150ml-2300-102-0150_1.jpg?ref=797790&w=2880&h=2880&mode=max&quality=75&format=webp",
    targetUrl:
      "https://ion.lyko.com/t/t?a=1117786221&as=1495527331&t=2&tk=1&epi=quiz&url=https://lyko.com/sv/ida-warg/ida-warg-self-tanning-mousse-150ml",
  },
  {
    type: "extra dark",
    name: "Ida Warg, Instant Self Tanning Mousse Extra Dark",
    imageUrl:
      "https://lykostatic.com/globalassets/product-images/ida-warg-instant-self-tanning-mousse-extra-dark-150-ml-2300-127-0150_1.jpg?ref=797803&w=2880&h=2880&mode=max&quality=75&format=webp",
    targetUrl:
      "https://ion.lyko.com/t/t?a=1117786221&as=1495527331&t=2&tk=1&epi=quiz&url=https://lyko.com/sv/ida-warg/ida-warg-instant-self-tanning-mousse-extra-dark-150-ml",
  },
];

let productType = [""];

function skinColoResponse(skinColor, sectionPoints) {
  switch (true) {
    case skinColor > 80:
      productType.push("mist");
      return "Din hudton är väldigt mörk och då ska man inte ta för starka.";
    case skinColor > 60:
      productType.push("medium");
      return "Du har en hudton som har en mörkare nyans, vilket gör att man inte ska ha allt för stark produkt.";
    case skinColor > 40:
      productType.push("extra dark");
      return "Du har en hudton som är perfekt för en brun utan sol som man tar en gång i månaden.";
    case skinColor > 20:
      productType.push("dark");
      return "När man har en ljusare hudton så kan det vara bra att ta brun utan sol iallfall en gång i veckan.";
    case skinColor <= 20:
      productType.push("mist");
      return "En superljus hudton kan vara svår när man tar stark brun utan sol, det kan bli väldigt fläckigt. Tänk på att ta en lättare variant.";
  }
}

function getSkinTypeResponse(skinType) {
  if (skinType.fat > skinType.halfFat && skinType.fat > skinType.dry) {
    productType.push("mousse");
    return "Med tanke på att du har en fetare hudton så ska du inte ha brun utan sol för ofta, då det kan bli fläckigt. Det är viktigt att tänka på att torka huden ordentligt när du applicerar bus.";
  } else if (
    skinType.fat <= skinType.halfFat &&
    skinType.halfFat > skinType.dry
  ) {
    productType.push("extra dark");
    productType.push("mousse");
    return "Lite fetare hud skadar inte, men det är viktigt att tänka på att torka huden ordentligt när du applicerar bus.";
  } else if (skinType.dry >= skinType.superDry) {
    productType.push("mist");
    return "Tänk på att när du har en torrare hud så kan det bli sprickor. Applicera försiktigt lite under flera dagar, istället för allt på en gång!";
  } else {
    productType.push("mist");
    return "Var beredd att du kommer få sprickor. Använd dig av mist istället för mousse för att få en lenare utjämning när du applicerar buset.";
  }
}

export default function MediaCard({ sectionPoints, sliderColor }) {
  const classes = useStyles();

  useEffect(() => {
    fetch(
      "https://l3payh8vwi.execute-api.eu-north-1.amazonaws.com/default/BusQuiz",
      {
        method: "POST",
        body: JSON.stringify({
          question: "quiz_results",
          id: uuidv4(),
          results: JSON.stringify({ sectionPoints, sliderColor }),
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        console.log(res);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div>
      <Card className={classes.root}>
        <CardActionArea>
          <CardContent style={{ margin: "2vh" }}>
            <Typography gutterBottom variant="h2" component="h2">
              Ditt resultat
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              {skinColoResponse(sliderColor)}
              {<br />}
              {<br />}
              {getSkinTypeResponse(sectionPoints)}
              {<br />}
              {<br />}
              Vi har tagit fram det bästa resultatet för dig som verkligen vill
              ha en produkt som passar just dig. Produkterna som vi har tagit
              fram är sorterade efter ditt behov.
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      <Typography gutterBottom variant="h5" component="h2">
        Perfekta produkter för dig!
      </Typography>
      {productList
        .filter((product) => {
          return productType.includes(product.type);
        })
        .map((product) => {
          return <ProductCard key={product} product={product} />;
        })}
    </div>
  );
}

function ProductCard({ product }) {
  const classes = useStyles();
  return (
    <div>
      <Card
        className={classes.root}
        onClick={(e) => {
          e.preventDefault();
          window.location.href = product.targetUrl;
        }}
      >
        <CardActionArea>
          <CardMedia
            className={classes.media}
            image={product.imageUrl}
            title={product.name}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {product.name}
            </Typography>
            <Typography gutterBottom variant="body2" component="body2">
              Produkten är framtagen genom dina beskrivningar och vi produkterna
              som vi rekommenderar finns alltid hos dom ledande inom hälsa och
              skönhet. Hoppas denna produkter är bra för dig!
            </Typography>
            <Button
              style={{
                marginTop: 20,
                width: "100%",
                fontWeight: "bold",
                backgroundColor: "#e38989",
                color: "white",
              }}
              variant="contained"
            >
              Kolla in produkten
            </Button>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Resultbox.js